export default "__VITE_ASSET__KmMk93It__"